import actions from "./templates-actions";
import getters from "./templates-getters";
import mutations from "./templates-mutations";
import state from "./templates-state";
const store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default store;